module.exports = __webpack_public_path__ + "img/nodata_global.616d3b5b.svg";